let typeX = null,
  typeY = null;

const minCellWidth = 50;

/**
 * 改变列宽
 * @param el
 * @param dragEl
 * @param vm
 * @param key
 * @param onChangeCol
 */
function changeWidth(el, dragEl, vm, key, onChangeCol) {
  initWidthList(el, vm, key);
  // 鼠标是否按下
  let isDown = false;
  // 记录鼠标按下的初始坐标
  let startX = 0;
  // 记录鼠标按下时虚线的初始坐标
  let dragElStartX = 0;
  // 记录虚线两边列的索引
  let thIndex = [0, 0];
  // 记录虚线可移动的左右长度范围
  let moveRange = [0, 0];
  // 事件处理
  vm.mousemoveW = function (eV) {
    const e = eV || window.event;
    let td = $(e.target).closest("td");
    if (!td.length || td.closest("table").get(0) !== el) {
      if (!isDown) {
        document.body.style.cursor = "";
      }
      return;
    }
    const x = getMouseOffsetByTd(e, td.get(0)).offsetX;
    typeX = checkMouse(td.get(0), x);
    if (typeX) {
      e.cancelBubble = true;
      e.stopPropagation();
    }
    if (typeX) {
      if (typeX === "left") {
        if (!isDown) {
          dragElStartX = td.get(0).offsetLeft;
          dragEl.style.left = dragElStartX + "px";
        }
      } else {
        if (!isDown) {
          dragElStartX = td.get(0).offsetLeft + td.get(0).offsetWidth;
          dragEl.style.left = dragElStartX + "px";
        }
      }
      if (document.body.style.cursor !== "col-resize") {
        document.body.style.cursor = "col-resize";
      }
    } else if (!isDown && document.body.style.cursor === "col-resize") {
      document.body.style.cursor = "";
    }
    if (isDown) {
      let scale = (window.$designerSscale || 100) / 100;
      let left = (e.screenX - startX) / scale;
      if (left > moveRange[1]) {
        left = moveRange[1];
      }
      if (left < moveRange[0]) {
        left = moveRange[0];
      }
      dragEl.style.left = dragElStartX + left + "px";
    }
  };
  vm.mousedownW = function (eV) {
    const e = eV || window.event;
    let td = $(e.target).closest("td");
    if (!td.length || td.closest("table").get(0) !== el) {
      return;
    }
    const x = getMouseOffsetByTd(e, td.get(0)).offsetX;
    typeX = checkMouse(td.get(0), x);
    if (typeX) {
      e.cancelBubble = true;
      e.stopPropagation();
    }
    if (!typeY && typeX) {
      startX = e.screenX;
      isDown = true;
      dragEl.style.visibility = "visible";
      document.body.style.cursor = "col-resize";
      if (typeX === "left") {
        thIndex[1] = +td.get(0).getAttribute("c-index").split(",")[1];
        thIndex[0] = thIndex[1] - 1;
      } else {
        const colspan0 = +td.get(0).getAttribute("colspan") || 1;
        thIndex[0] =
          +td.get(0).getAttribute("c-index").split(",")[1] + colspan0 - 1;
        thIndex[1] = thIndex[0] + 1;
      }
      // const widthList = JSON.parse(JSON.stringify(vm[key]));
      // const tableWidth = el.offsetWidth;
      let w0 = el.querySelector(`thead th:nth-child(${thIndex[0] + 1})`).offsetWidth;
      let w1 = el.querySelector(`thead th:nth-child(${thIndex[1] + 1})`).offsetWidth;
      moveRange[0] = minCellWidth - w0;
      moveRange[1] = w1 - minCellWidth;
    }

  };
  vm.mouseupW = function (eV) {
    const e = eV || window.event;
    if (!isDown) {
      return;
    }
    e.cancelBubble = true;
    e.stopPropagation();
    dragEl.style.visibility = "hidden";
    document.body.style.cursor = "";
    isDown = false;
    resetSize();
  };

  // 边缘碰撞校验
  function checkMouse(el, x) {
    const cIndex = el.getAttribute("c-index").split(",");
    if (cIndex[1] === "0") {
      return x > el.offsetWidth - 5 ? "right" : null;
    }
    if (!el.nextElementSibling) {
      return x < 5 ? "left" : null;
    }
    if (x > el.offsetWidth - 5) {
      return "right";
    }
    if (x < 5) {
      return "left";
    }
  }
  // 更新列宽
  function resetSize() {
    let newList = JSON.parse(JSON.stringify(vm[key]));
    const tableWidth = el.offsetWidth;
    let offWidth = parseInt(dragEl.style.left) - dragElStartX;

    // let width0 = newList[thIndex[0]].width;
    // let width1 = newList[thIndex[1]].width;

    let w0 = el.querySelector(`thead th:nth-child(${thIndex[0] + 1})`).offsetWidth + offWidth;
    let w1 = el.querySelector(`thead th:nth-child(${thIndex[1] + 1})`).offsetWidth - offWidth;
    if (w0 < minCellWidth || w1 < minCellWidth) return;
    newList[thIndex[0]] = {
      width: _.round(w0 * 100 / tableWidth, 3) + "%",
    };
    newList[thIndex[1]] = {
      width: _.round(w1 * 100 / tableWidth, 3) + "%",
    };

    // if (!width0 || width0 === 'auto') {
    //   let w = el.querySelector(`thead th:nth-child(${thIndex[0] + 1})`).offsetWidth + offWidth;
    //   newList[thIndex[0]] = {
    //     width: (w * 100 / tableWidth).toFixed(3) + "%",
    //   };
    // } else if (width0.indexOf('%') > -1) {
    //   width0 = (parseFloat(width0) * tableWidth) / 100 + offWidth;
    //   newList[thIndex[0]] = {
    //     width: ((width0 * 100) / tableWidth).toFixed(3) + "%",
    //   };
    // } else {
    //   newList[thIndex[0]] = {
    //     width: parseFloat(width0) + offWidth + "px",
    //   };
    // }
    // if (!width1 || width1 === 'auto') {
    //   let w = el.querySelector(`thead th:nth-child(${thIndex[1] + 1})`).offsetWidth - offWidth;
    //   newList[thIndex[1]] = {
    //     width: (w * 100 / tableWidth).toFixed(3) + "%",
    //   };
    // } else if (width1.indexOf('%') > -1) {
    //   width1 = (parseFloat(width1) * tableWidth) / 100 - offWidth;
    //   newList[thIndex[1]] = {
    //     width: ((width1 * 100) / tableWidth).toFixed(3) + "%",
    //   };
    // } else {
    //   newList[thIndex[1]] = {
    //     width: parseFloat(width1) - offWidth + "px",
    //   };
    // }

    onChangeCol && onChangeCol(newList);
  }

}

/**
 * 改变行高
 * @param el
 * @param dragEl
 * @param vm
 * @param key
 * @param onChangeRow
 */
function changeHeight(el, dragEl, vm, key, onChangeRow) {
  // 鼠标是否按下
  let isDown = false;
  // 记录鼠标按下的初始坐标
  let startY = 0;
  // 记录鼠标按下时虚线的初始坐标
  let dragElStartY = 0;
  // 当前处理的行tr
  let target = null;
  // 记录虚线可向上移动的长度范围
  let moveRange = 0;
  // 事件处理
  vm.mousemoveH = function (eV) {
    const e = eV || window.event;
    let td = $(e.target).closest("td");
    if (!td.length || td.closest("table").get(0) !== el) {
      if (!isDown) {
        document.body.style.cursor = "";
      }
      return;
    }
    const y = getMouseOffsetByTd(e, td.get(0)).offsetY;
    typeY = checkMouse(td.get(0), y);
    if (typeY) {
      e.cancelBubble = true;
      e.stopPropagation();
      if (typeY === "top") {
        if (!isDown) {
          dragElStartY = td.get(0).parentElement.offsetTop;
          dragEl.style.top = dragElStartY + "px";
        }
      } else {
        if (!isDown) {
          dragElStartY =
            td.get(0).parentElement.offsetTop +
            td.get(0).parentElement.offsetHeight;
          dragEl.style.top = dragElStartY + "px";
        }
      }
      if (document.body.style.cursor !== "row-resize") {
        document.body.style.cursor = "row-resize";
      }
    } else if (!isDown && document.body.style.cursor === "row-resize") {
      document.body.style.cursor = "";
    }
    if (isDown) {
      let scale = (window.$designerSscale || 100) / 100;
      let top = (e.screenY - startY) / scale;
      if (top < moveRange) {
        top = moveRange;
      }
      dragEl.style.top = dragElStartY + top + "px";
    }
  };
  vm.mousedownH = function (eV) {
    const e = eV || window.event;
    let td = $(e.target).closest("td");
    if (!td.length || td.closest("table").get(0) !== el) {
      return;
    }
    const y = getMouseOffsetByTd(e, td.get(0)).offsetY;
    typeY = checkMouse(td.get(0), y);
    if (typeY) {
      e.cancelBubble = true;
      e.stopPropagation();
    }
    if (typeY && !typeX) {
      startY = e.screenY;
      isDown = true;
      dragEl.style.visibility = "visible";
      document.body.style.cursor = "row-resize";
      if (typeY === "top") {
        target = td.get(0).parentElement.previousElementSibling;
      } else {
        target = td.get(0).parentElement;
      }
      moveRange = 57 - target.offsetHeight;
    }
  };
  vm.mouseupH = function (eV) {
    const e = eV || window.event;
    if (!isDown) {
      return;
    }
    e.cancelBubble = true;
    e.stopPropagation();
    dragEl.style.visibility = "hidden";
    document.body.style.cursor = "";
    isDown = false;
    resetSize();
  };
  // 边缘碰撞校验
  function checkMouse(el, y) {
    const cIndex = el.getAttribute("c-index");
    if (!cIndex || cIndex === "") return;
    const rIndex = el.getAttribute("c-index").split(",")[0];
    if (rIndex === "0") {
      return y > el.offsetHeight - 5 ? "bottom" : undefined;
    }
    if (y > el.offsetHeight - 5) {
      return "bottom";
    }
    if (y < 5) {
      return "top";
    }
  }
  // 更新行高
  function resetSize() {
    let offHeight = parseInt(dragEl.style.top) - dragElStartY;
    const rIndex = +target.children[0].getAttribute("c-index").split(",")[0];
    onChangeRow && onChangeRow(rIndex, target.offsetHeight + offHeight + "px");
  }
}

/**
 * 获取鼠标相对于td的坐标
 * @param e
 * @param td
 * @returns {{offsetX: number, offsetY: number}}
 */
function getMouseOffsetByTd(e, td) {
  let {offsetX, offsetY, target} = e;
  if (!td) return {offsetX, offsetY};
  while (target !== td) {
    offsetX += target.offsetLeft;
    offsetY += target.offsetTop;
    target = target.parentNode;
    if (target === document.body) {
      offsetX = 0;
      offsetY = 0;
      break;
    }
  }
  return {offsetX, offsetY};
}

/**
 * 创建拖动时的虚线dom，并插入table中
 * @param el
 * @param type
 * @returns {HTMLDivElement}
 */
function createDragEl(el, type) {
  const dom = document.createElement("div");
  dom.style.position = "absolute";
  dom.style.display = "block";
  dom.style.visibility = "hidden";
  dom.style.top = "0";
  dom.style.left = "0";
  dom.style.zIndex = "10000";
  if (type === "x") {
    dom.style.height = "100%";
    dom.style.width = "1px";
    dom.style.borderLeft = "1px dashed #000";
  } else {
    dom.style.width = "100%";
    dom.style.height = "1px";
    dom.style.borderTop = "1px dashed #000";
  }
  // ie下空标签不显示，我也不知道为什么...
  // 加点内容就显示了！
  dom.innerHTML = '<span></span>';
  if (
    el.style.position !== "relative" &&
    el.style.position !== "absolute" &&
    el.style.position !== "fixed"
  ) {
    el.style.position = "relative";
  }
  el.appendChild(dom);
  return dom;
}

/**
 * 初始化列宽，将auto、px转%
 * @param el
 * @param vm
 * @param key
 */
function initWidthList(el, vm, key) {
  // const tableWidth = el.offsetWidth;
  const widthList = JSON.parse(JSON.stringify(vm[key]));
  // let autoNum = 0,
  //   hasWidth = 0;
  // const newList = [];
  vm.__col_number = widthList.length;
  // widthList.forEach(({ width }, index) => {
  //   if (width !== 0 && (!width || width === "" || width === "auto")) {
  //     autoNum++;
  //     newList[index] = null;
  //   } else if (typeof width === "string" && width.indexOf("%") > 0) {
  //     if (isNaN(parseFloat(width))) {
  //       autoNum++;
  //       newList[index] = null;
  //     } else {
  //       const _w = parseFloat(width);
  //       hasWidth += _w;
  //       newList[index] = { width: _w.toFixed(3) + "%" };
  //     }
  //   } else if (typeof width === "string" && width.indexOf("px") > 0) {
  //     if (isNaN(parseFloat(width))) {
  //       autoNum++;
  //       newList[index] = null;
  //     } else {
  //       const _w = (parseFloat(width) * 100) / tableWidth;
  //       hasWidth += _w;
  //       newList[index] = { width: _w.toFixed(3) + "%" };
  //     }
  //   } else if (isNaN(parseFloat(width))) {
  //     autoNum++;
  //     newList[index] = null;
  //   } else {
  //     const _w = parseFloat(width);
  //     hasWidth += _w;
  //     newList[index] = { width: _w.toFixed(3) + "%" };
  //   }
  // });
  // if (hasWidth > 100) {
  //   for (let i = 0; i < tableWidth.length; i++) {
  //     if (!newList[i]) {
  //       newList[i] = { width: 0 };
  //     } else {
  //       newList[i] = {
  //         width: (parseFloat(newList[i].width) / hasWidth).toFixed(3) + "%",
  //       };
  //     }
  //   }
  // } else if (autoNum > 0) {
  //   let autoWidth = ((100 - hasWidth) / autoNum).toFixed(3) + "%";
  //   for (let i = 0; i < widthList.length; i++) {
  //     if (!newList[i]) {
  //       newList[i] = { width: autoWidth };
  //     }
  //   }
  // }
  // vm.$emit("update:" + key, newList);
}

/**
 * 更新列宽, 增加了列，或减少了列
 * @param el
 * @param vm
 * @param key
 * @param onChangeCol
 */
function updateWidthList(el, vm, key, onChangeCol) {
  const tableWidth = el.offsetWidth;
  const widthList = JSON.parse(JSON.stringify(vm[key]));
  const newList = [];
  let oldColNum = vm.__col_number;
  vm.__col_number = widthList.length;
  const k = oldColNum / widthList.length;
  const newWidth = 100 / widthList.length;
  widthList.forEach(({ width }, index) => {
    if (width !== 0 && (!width || width === "" || width === "auto")) {
      newList[index] = { width: "auto" };
    } else if (typeof width === "string" && width.indexOf("%") > 0) {
      const _w = parseFloat(width) * k;
      newList[index] = { width: _.round(_w, 3) + "%" };
    } else if (typeof width === "string" && width.indexOf("px") > 0) {
      const _w = (parseFloat(width) * 100 * k) / tableWidth;
      newList[index] = { width: _.round(_w, 3) + "%" };
    } else {
      const _w = parseFloat(width) * k;
      newList[index] = { width: _.round(_w, 3) + "%" };
    }
  });
  onChangeCol && onChangeCol(newList);
}


export default {
  resize: {
    inserted(el, { value, modifiers }, vnode) {
      // 当前实例
      const vm = vnode.context;
      if (!vm.isDesign) {
        return;
      }
      // 改变列宽
      if (modifiers.x || (!modifiers.x && !modifiers.y)) {
        changeWidth(
          el,
          createDragEl(el, "x"),
          vm,
          value.colList,
          value.onChangeCol
        );
        window.addEventListener("mousemove", vm.mousemoveW);
        el.addEventListener("mousedown", vm.mousedownW);
        window.addEventListener("mouseup", vm.mouseupW);
        el.addEventListener("mouseleave", vm.mouseupW);
      }
      // 改变行高
      if (modifiers.y || (!modifiers.x && !modifiers.y)) {
        changeHeight(
          el,
          createDragEl(el, "y"),
          vm,
          value.rowList,
          value.onChangeRow
        );
        window.addEventListener("mousemove", vm.mousemoveH);
        el.addEventListener("mousedown", vm.mousedownH);
        window.addEventListener("mouseup", vm.mouseupH);
      }
      el.mouseleave = function () {
        document.body.style.cursor = "";
      };
      window.addEventListener("mouseleave", el.mouseleave, {capture: true});
    },
    update(el, { value, modifiers }, vnode) {
      const vm = vnode.context;
      if (!vm.isDesign) {
        return;
      }
      // 改变列宽
      if (modifiers.x || (!modifiers.x && !modifiers.y)) {
        if (vm.__col_number !== vm[value.colList].length) {
          updateWidthList(el, vm, value.colList, value.onChangeCol);
        }
      }
    },
    unbind(el, { modifiers }, vnode) {
      const vm = vnode.context;
      if (!vm.isDesign) {
        return;
      }
      // 改变列宽
      if (modifiers.x || (!modifiers.x && !modifiers.y)) {
        window.removeEventListener("mousemove", vm.mousemoveW);
        el.removeEventListener("mousedown", vm.mousedownW);
        window.removeEventListener("mouseup", vm.mouseupW);
        el.removeEventListener("mouseleave", vm.mouseupW);
      }
      // 改变行高
      if (modifiers.y || (!modifiers.x && !modifiers.y)) {
        window.removeEventListener("mousemove", vm.mousemoveH);
        el.removeEventListener("mousedown", vm.mousedownH);
        window.removeEventListener("mouseup", vm.mouseupH);
      }
      window.removeEventListener("mouseleave", el.mouseleave, {capture: true});
    },
  },
};
